import { get } from 'lodash';
import React from 'react';
import { ANTRAGS_FORMULAREN, KOSTEN_ARTEN, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import { assignIdsToStruc } from 'src/utils/helper';
import ApplicationHeading from '../../application-heading/ApplicationHeading';
import { hasAnyNachweisPositionComment } from '../../application-helper-function/AppHelperfunctions';
import Abruf, { formStrucAbruf } from './content/Abruf';
import AbschlussMittelabruf, { getFormStrucAbschlussMittelabruf } from './content/AbschlussMittelabruf';
import BankDaten, { getFormStrucBankDaten } from './content/BankDaten';
import EigenmittelUebersichtMA from './content/eigenmittel/EigenmittelUebersichtMA';
import { GetEigenmittelMA } from './content/eigenmittel/GetEigenmittelMA';
import ErklaerungAbruf, { formStrucErklaerungAbruf } from './content/Erklaerung';
import { GetInvestitionsKostenMA } from './content/investitionskosten/GetInvestitionsKostenMA';
import InvestitionsKostenUebersichtMA from './content/investitionskosten/InvestitionsKostenUebersichtMA';
import { GetPersonalKostenMA } from './content/personalkosten/GetPersonalKostenMA';
import PersonalKostenUebersichtMA from './content/personalkosten/PersonalKostenUebersichtMA';
import { GetReiseKostenMA } from './content/reisekosten/GetReiseKostenMA';
import ReiseKostenUebersichtMA from './content/reisekosten/ReiseKostenUebersichtMA';
import { GetSachkostenMA } from './content/sachkosten/GetSachkostenMA';
import SachkostenUebersichtMA from './content/sachkosten/SachkostenUebersichtMA';
import { TreeStructureMaEpz } from './epz/TreestructureMaEpz';
import { TreeStructureMAKreativ } from './kreativ/TreeStructureMAKreativ';

// import Schemas
import KostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
import MittelAbrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import NachweisPositoinSchema from 'src/lib/paths/nachweisposition_FULL_Paths.json';
import { TreeStructureMALoewe } from './loewe/TreeStructureMALoewe';
import { TreeStructureMAStipendium } from './stipendium/TreeStructureMAStipendium';
import { TreeStructureWichtigeHinweiseMA } from './default-content/wichtige-hinweise/TreeStructureWichtigeHinweiseMA';
const KP_P = KostenPositionSchema.attributes;
const MA_P = MittelAbrufSchema.attributes;
const NP_P = NachweisPositoinSchema.attributes;

export const TreeStructureMittelabruf = (application: any, readOnly: boolean) => {
	let treeNodes: TreeNodeType[] = [];
	const antragFormular = get(application, MA_P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path, '');
	switch (antragFormular) {
		case ANTRAGS_FORMULAREN.Entwicklungszusammenarbeit:
			treeNodes = TreeStructureMaEpz(application);
			break;
		case ANTRAGS_FORMULAREN.Kreativwirtschaft:
			treeNodes = TreeStructureMAKreativ(application);
			break;
		case ANTRAGS_FORMULAREN.StartUpStipendium:
			treeNodes = TreeStructureMAStipendium(application);
			break;
		case ANTRAGS_FORMULAREN.Loewe:
			treeNodes = TreeStructureMALoewe(application);
			break;
		default:
			treeNodes = getDefaultTreeStructureMA(application, readOnly);
			break;
	}

	return assignIdsToStruc(treeNodes);
};

const getDefaultTreeStructureMA = (application: any, readOnly: boolean) => {
	const allKostenArt = get(application, MA_P.Foerderantrag.schema.attributes.Foerderantrag_Kostenpositions.path, []).map((eachPosition: any) =>
		get(eachPosition, KP_P.Allgemein_Kostenart_Finanzierung.path),
	);

	let treeNodes: TreeNodeType[] = [
		...TreeStructureWichtigeHinweiseMA(application),
		{ label: 'Überprüfung', content: <BankDaten />, formStruc: getFormStrucBankDaten(application) },
		{ label: 'Abruf', content: <Abruf />, formStruc: formStrucAbruf(application) },
		...PersonalkostenStructure(allKostenArt, application, readOnly),
		...SachkostenStructure(allKostenArt, application, readOnly),
		...Investitionskostentructure(allKostenArt, application, readOnly),
		...ReisekostenStructure(allKostenArt, application, readOnly),
		...EingenmittelStructure(allKostenArt, application, readOnly),
		{ label: 'Erklärung', content: <ErklaerungAbruf />, formStruc: formStrucErklaerungAbruf() },
		{ label: 'Mitelabruf Übersicht', content: <AbschlussMittelabruf />, formStruc: getFormStrucAbschlussMittelabruf() },
	];

	return treeNodes;
};

const PersonalkostenStructure = (allKostenArt: any[], application: any, readOnly: boolean) => {
	let nodes: TreeNodeType[] = [];

	if (allKostenArt.includes(KOSTEN_ARTEN.Personalkosten)) {
		nodes = [
			{
				label: 'Personalkosten',
				content: <ApplicationHeading title='Personalkosten' description={PLATZHALTER_TEXT} />,
				children: GetPersonalKostenMA(application, readOnly),
				hasComment: hasAnyNachweisPositionComment(
					readOnly,
					application,
					MA_P.Mittelabruf_Nachweispositions.path,
					'KostenArt',
					0,
					NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenart_Finanzierung.path,
					KOSTEN_ARTEN.Personalkosten,
				),
			},
			{
				label: 'Personalkosten Übersicht',
				content: <PersonalKostenUebersichtMA />,
			},
		];
	}
	return nodes;
};
const SachkostenStructure = (allkostenArt: any[], application: any, readOnly: boolean) => {
	let nodes: TreeNodeType[] = [];
	if (allkostenArt.includes(KOSTEN_ARTEN.Sachkosten)) {
		nodes = [
			{
				label: 'Sachkosten',
				content: <ApplicationHeading title='Sachkosten' description={PLATZHALTER_TEXT} />,
				children: GetSachkostenMA(application, readOnly),
				hasComment: hasAnyNachweisPositionComment(
					readOnly,
					application,
					MA_P.Mittelabruf_Nachweispositions.path,
					'KostenArt',
					0,
					NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenart_Finanzierung.path,
					KOSTEN_ARTEN.Sachkosten,
				),
			},
			{
				label: 'Sachkosten Übersicht',
				content: <SachkostenUebersichtMA />,
			},
		];
	}
	return nodes;
};
const Investitionskostentructure = (allkostenArt: any[], application: any, readOnly: boolean) => {
	let nodes: TreeNodeType[] = [];
	if (allkostenArt.includes(KOSTEN_ARTEN.Investitionskosten)) {
		nodes = [
			{
				label: 'Investitionskosten',
				content: <ApplicationHeading title='Investitionskosten' description={PLATZHALTER_TEXT} />,
				children: GetInvestitionsKostenMA(application, readOnly),
				hasComment: hasAnyNachweisPositionComment(
					readOnly,
					application,
					MA_P.Mittelabruf_Nachweispositions.path,
					'KostenArt',
					0,
					NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenart_Finanzierung.path,
					KOSTEN_ARTEN.Investitionskosten,
				),
			},
			{
				label: 'Investitionskosten Übersicht',
				content: <InvestitionsKostenUebersichtMA />,
			},
		];
	}
	return nodes;
};
const ReisekostenStructure = (allkostenArt: any[], application: any, readOnly: boolean) => {
	let nodes: TreeNodeType[] = [];

	if (allkostenArt.includes(KOSTEN_ARTEN.Reisekosten)) {
		nodes = [
			{
				label: 'Reisekosten',
				content: <ApplicationHeading title='Reisekosten' description={PLATZHALTER_TEXT} />,
				children: GetReiseKostenMA(application, readOnly),
				hasComment: hasAnyNachweisPositionComment(
					readOnly,
					application,
					MA_P.Mittelabruf_Nachweispositions.path,
					'KostenArt',
					0,
					NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenart_Finanzierung.path,
					KOSTEN_ARTEN.Investitionskosten,
				),
			},
			{
				label: 'Reisekosten Übersicht',
				content: <ReiseKostenUebersichtMA />,
			},
		];
	}
	return nodes;
};
const EingenmittelStructure = (allkostenArt: any[], application: any, readOnly: boolean) => {
	let nodes: TreeNodeType[] = [];
	if (allkostenArt.includes(KOSTEN_ARTEN.Eigenmittel)) {
		nodes = [
			{
				label: 'Eigen- und Drittmittel',
				content: <ApplicationHeading title='Eigen- und Drittmittel' description={PLATZHALTER_TEXT} />,
				children: GetEigenmittelMA(application, readOnly),
				hasComment: hasAnyNachweisPositionComment(
					readOnly,
					application,
					MA_P.Mittelabruf_Nachweispositions.path,
					'KostenArt',
					0,
					NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenart_Finanzierung.path,
					KOSTEN_ARTEN.Eigenmittel,
				),
			},
			{
				label: 'Eigen- und Drittmittel Übersicht',
				content: <EigenmittelUebersichtMA />,
			},
		];
	}
	return nodes;
};
